<template>
    <div class="wrap">
        <div class="kv">
        </div>

        <div class="info">
            <div>
                <span>评委：</span>
                <span>{{judge.name}}</span>
            </div>
            <div>
                <span>病例：</span>
                <span>{{judge.quota}}</span>
            </div>
            <div>
                <span>已分配病例：</span>
                <span>{{data.length}}</span>
            </div>
            <div>
                <span>已评论病例：</span>
                <span>{{scoredNumber}}</span>
            </div>
        </div>
        <div class="explain">
            <div class="explain-item">
                <div style="background: #0082C5"></div>
                <span>未打分</span>
            </div>
            <div class="explain-item">
                <div style="background: red"></div>
                <span>已打分</span>
            </div>
        </div>

        <div class="content" id="content">
            <div id="item" :class='["item",item.scored==0?"item-scored":""]' v-for="(item,index) in data" v-bind:key="index" @click="itemClick(item.case_id)">
                    <div  class="item-wrap">
                        <img src="../../assets/img/icon_yes.png" v-if="item.is_scored==0">
                        <img src="../../assets/img/icon_no.png" v-if="item.is_scored==1">
                        <span>病例{{index+1}}</span>
                        <label>点击评审</label>
                    </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getJudgeCase} from "@/assets/js/api";

    export default {
        name: '',
        data() {
            return {
                judgeId:this.$route.query.judgeId,
                data:[""],
                scoredNumber:0,
                judge:{
                    judgeId:"",
                    name:"",
                    phone:"",
                    quota:0,
                },
            }
        },
        mounted(){
            this.getCase(this.judgeId)
        },
        methods: {
            async getCase(judgeId){
                console.log(judgeId,"judgeId")
                const res = await getJudgeCase({judgeId})
                console.log(res,"12345")
                this.data = res.data.data.score

                for(let item in this.data){
                    if (this.data[item].is_scored==1) this.scoredNumber++
                }

                this.judge = res.data.data.judge
            },
            heightWatching:function () {
                let divWidth =  document.getElementById("item").offsetWidth;
                document.getElementById("item").style.height = divWidth+"px"

            },
            itemClick(caseId){
                let judgeId = this.judge.judgeId
                this.$router.push({path:"/wx_score",query:{caseId:caseId,judgeId:judgeId}})
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .wrap {
        width: 100%;
        max-width: 500px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #FFF;
        margin: 0 auto;
        overflow: scroll;
    }

    .kv{
        width: 100%;
        padding: 56.25% 0 0;
        background: #FFF url("../../assets/img/wx_kv.jpg") no-repeat;
        background-size: 100% 100% ;
    }

    .content{
        /*display: grid;*/
        /*grid-template-columns: repeat(3,1fr);*/
        /*grid-gap: 10px;*/
        /*margin: 10px;*/
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .item{
        /*background: #0082c5;*/
        width: 30%;
        margin: 5px 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: #0082C5 1px solid;
        border-radius: 10px;

        .item-wrap{
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 16px;
            span{
                margin-bottom: 5px;
            }
        }
    }


    img{
        width: 80px;
        height: 80px;
    }

    .plus{
        width: 100px;
        height: 100px;
    }

    .explain {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin: 8px 5%;

        .explain-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 15px;

            div {
                width: 12px;
                height: 12px;
            }

            span {
                color: #0082C5;
            }
        }
    }

    .info {
        width: 90%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        background: #0082C5;
        margin: 10px auto;
        text-align: left;
        padding: 5px;
        color: #FFF;
        font-size: 20px;
        height: 180px;

        span {
            margin: 5px;
        }
    }

    label{
        background: #0082C5;
        color: #FFF;
        margin-bottom: 10px;
        border-radius: 10px;
    }

</style>
